import { ICurrentSubscription, ISubscriptionPlan, SecurityModel } from '../models';
import { ResponseViewModel } from '../view-models/responses/response-viewmodel';
import { ApiService } from './api-service';

type Platform = 'AuthorizeNet' | 'GooglePlayStore' | 'AppStore';

export const getIsIAPPurchaseEnabled = async (): Promise<ResponseViewModel<boolean>> => {
  const url = '/payments/Mobile/IsInAppPurchaseEnabled';
  const response = await ApiService.instance.get<boolean>(url);
  const vm = new ResponseViewModel<boolean>();
  vm.data = response.data as unknown as boolean;
  vm.errors = response.errors;
  return vm;
};

export const getPaymentPlans = async (): Promise<ResponseViewModel<ICurrentSubscription>> => {
  const url = '/payments/getPaymentPlans';
  const response = await ApiService.instance.get<ICurrentSubscription>(url);
  const vm = new ResponseViewModel<ICurrentSubscription>();
  vm.data = response.data as unknown as ICurrentSubscription;
  vm.errors = response.errors;
  return vm;
};

export const getPaymentPlansMobile = async (platform: Platform): Promise<ResponseViewModel<ISubscriptionPlan[]>> => {
  const url = `/payments/Mobile/GetSubscriptionPackages?platform=${platform}`;
  const response = await ApiService.instance.get<ISubscriptionPlan[]>(url);
  const vm = new ResponseViewModel<ISubscriptionPlan[]>();
  vm.data = response.data as unknown as ISubscriptionPlan[];
  vm.errors = response.errors;
  return vm;
};

export const validateSubscription = async (request: any): Promise<ResponseViewModel<SecurityModel | null>> => {
  const url = '/payments/Mobile/ValidateSubscription';
  const response = await ApiService.instance.post<any, SecurityModel>(url, request);
  const editReponse = SecurityModel.fromJson(response.data);
  const vm = new ResponseViewModel<SecurityModel>();
  vm.data = editReponse as unknown as SecurityModel;
  vm.errors = response.errors;
  return vm;
};

export const addSubscription = async (request: any): Promise<ResponseViewModel<SecurityModel | null>> => {
  const url = '/payments/addSubscription';
  const response = await ApiService.instance.put<any, SecurityModel>(url, request);
  const editReponse = SecurityModel.fromJson(response.data); //SecurityModel.fromSubscriptionData(response as any);
  const vm = new ResponseViewModel<SecurityModel>();
  vm.data = editReponse as unknown as SecurityModel;
  vm.errors = response.errors;
  return vm;
};

export const changeSubscriptionInformation = async (request: any): Promise<ResponseViewModel<SecurityModel | null>> => {
  const url = '/payments/changeInformation';
  const response = await ApiService.instance.post<any, SecurityModel>(url, request);
  const editReponse = SecurityModel.fromSubscriptionData(response as any);
  const vm = new ResponseViewModel<SecurityModel>();
  vm.data = editReponse as unknown as SecurityModel;
  vm.errors = response.errors;
  return vm;
};

export const cancelsubscription = async (request: any): Promise<ResponseViewModel<SecurityModel | null>> => {
  const url = '/payments/cancelSubscription';
  const response = await ApiService.instance.post<any, SecurityModel>(url, request);
  const editReponse = SecurityModel.fromSubscriptionData(response as any);
  const vm = new ResponseViewModel<SecurityModel>();
  vm.data = editReponse as unknown as SecurityModel;
  vm.errors = response.errors;
  return vm;
};
